import React from 'react';
import { useLanguage } from "../../../hooks/Language";
import { Children } from "react";
import { SubtitleUI } from "./styles";

interface IProps {
    children?: React.ReactNode;
    style?: Record<string, any>;
    theme?: 'dark' | 'light';
    className?: string;
}

const Subtitle: React.FC<IProps> = ({ children, style, theme, className }) => {
    const { translate } = useLanguage();

    return <SubtitleUI className={className} themeValue={theme} style={style}>{translate(children)}</SubtitleUI>;
}

export default Subtitle;